import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ReceiveOrderListSearchCriteria, ReceiveOrderView } from '../model/receive-order.model';

@Injectable({
  providedIn: 'root'
})
export class ReceiveOrderService extends BaseService {
  public override headers: HttpHeaders;
  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.receiveOrder;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getReceiveOrderView(payload: { docNo: string; roType: string }): Observable<ReceiveOrderView> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.view, {
      storeNo,
      roType: payload.roType,
      docNo: payload.docNo
    });

    return this.http
      .get<ReceiveOrderView>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );

    // return of(receiveOrderFromWareHouse);
  }

  public list(criteria: ReceiveOrderListSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.requestList, {
      storeNo
    });
    const params = this.getParams(criteria);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public printReceiveOrder(request: any): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;

    const url = this.getFullUrl(this.envService.printRO, {
      storeNo,
      roType: request.roType,
      docNo: request.docNo
    });

    return this.http.get<any>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }
}

export const receiveOrderFromWareHouse = {
  type: 'WAREHOUSE',
  docNo: 'RO24-PANDA02-0011',
  refNo: 'DO24-PANDA02-0007',
  sender: 'คลังสินค้า',
  grBy: 'Dear Cjx',
  docDate: '2024-08-14T09:33:00.328Z',
  amount: 1092.06,
  notReceiveList: [
    {
      productName: 'TB4542007',
      barcode: '-',
      unit: 'CAR',
      deliverQty: 0,
      receiveQty: 0,
      notReceiveQty: 1000
    },
    {
      productName: '๑00พลัสเลมอนไลม์ 370ml',
      barcode: '8851952141288',
      unit: 'PC',
      deliverQty: 2000,
      receiveQty: 1000,
      notReceiveQty: 1000
    }
  ],
  claimList: [
    {
      toteId: 'PL',
      productName: '๑00พลัสเลมอนไลม์ 370ml',
      allClaimQty: 1,
      unit: 'PC',
      reasons: [
        {
          reason: 'แตกหักเสียหาย',
          claimQty: 1000
        },
        {
          reason: 'แตกหักเสียหาย',
          claimQty: 1
        },
        {
          reason: 'แตกหักเสียหาย',
          claimQty: 1
        }
      ]
    }
  ],
  returnedToteList: [],
  expectedReturnedToteQty: 1000,
  actualReturnedToteQty: 1000,
  notOwnReturnedToteQty: 1000,
  allTotesReturned: true,
  deliveryOrderList: [
    {
      productName: '108 shopppp ผงซักฟอกสูตรมาตรฐาน 1000 g',
      barcode: '-',
      unit: 'CAR',
      deliverQty: 1000
    },
    {
      productName: '๑00พลัสเลมอนไลม์ 370ml',
      barcode: '-',
      unit: 'PC',
      deliverQty: 2
    }
  ]
};

export const receiveOrderFreshlite = {
  type: 'FRESH_LITE',
  docNo: 'RO24-CJX00741-0006',
  refNo: 'FL_060824154858',
  sender: 'บริษัท เพรซิเดนท์เบเกอรี่ จำกัด (มหาชน)',
  grBy: 'พีพีซีเจเอ็กซ์ เดฟโลคอล',
  docDate: '2024-08-06T08:51:50.812Z',
  amount: 9115.9,
  goodsReceiveList: [
    {
      productName: 'ฟาร์มเฮ้าส์ขนมปังกลิ่นนมฮอกไกโด 240g',
      barcode: '8850123110535',
      unitTH: 'ลัง',
      qty: 0,
      baseUnitTH: 'ชิ้น',
      unitPrice: 0,
      price: 0,
      unitFactor: 32,
      supplierRefNumber: '20003702'
    },
    {
      productName: 'ฟาร์มเฮ้าส์ขนมปังกรอบอบเนย 65g MP',
      barcode: '8850123194115',
      unitTH: 'ลัง',
      qty: 33333,
      baseUnitTH: 'ชิ้น',
      unitPrice: 1115,
      price: 11145.42,
      unitFactor: 32,
      supplierRefNumber: '20003702'
    }
  ]
};

export const receiveSupplierList = {
  type: 'SUPPLIER',
  docNo: 'RO24-PANDA02-0014',
  refNo: 'OD24-PANDA02-0021',
  sender: 'บริษัท คิงส์ วิช จำกัด',
  grBy: 'Dear Cjx',
  docDate: '2024-08-14T12:07:18.318Z',
  goodsReceiveList: [
    {
      productName: 'คิงส์วิชซีฟู้ดรวมมิตรแช่แข็ง(หมึก/ปลา/ปูอัด) 500g',
      barcode: '8859526800609',
      deliverQty: 1,
      baseUnitTH: 'ชิ้น'
    },
    {
      productName: 'คิงส์วิชเนื้อหมึกหลอดหั่นวงใหญ่ 500g',
      barcode: '8859526801453',
      deliverQty: 1,
      baseUnitTH: 'ชิ้น'
    },
    {
      productName: 'คิงส์วิชเต้าหู้ปลาแบบเต๋า 500g',
      barcode: '8859526804683',
      deliverQty: 1,
      baseUnitTH: 'ชิ้น'
    }
  ]
};
